import React, { useMemo, useState } from 'react';
import { Card, CardBody, Col, Container, Button } from 'reactstrap';
import DataTable, { TableColumn } from 'react-data-table-component';
import { Link } from 'react-router-dom';
import { useIteamResource } from '../../../hook/ShowTable/generic';
import FilterComponent from '../../../Components/Tables/DataTables/Common/FilterComponent';
import Loader from '../../../Components/Widgets/Loader/generic';
import { Btn, H3 } from '../../../AbstractElements';

export interface PermissionTypeRow {
  ID: string | number;
  nome: string | null;
  descrizione: string | null;
  abilitato: number; // 1/0
}

export default function Index() {
  const [filterText, setFilterText] = useState('');

  // GET -> permissions/typeList
  const { data: rows, loading } = useIteamResource<PermissionTypeRow[]>('permissions/typeList');

  const filteredRows: PermissionTypeRow[] = useMemo(() => {
    const list = rows ?? [];
    if (!filterText) return list;
    const q = filterText.toLowerCase();

    return list.filter((r) => (r.nome ?? '').toString().toLowerCase().includes(q));
  }, [rows, filterText]);

  const handleDelete = (row: PermissionTypeRow) => {
    console.log('Delete', row);
  };

  const columns: TableColumn<PermissionTypeRow>[] = useMemo(
    () => [
      {
        name: 'Nome',
        selector: (row) => row.nome ?? '',
        sortable: true,
        grow: 2,
      },
      {
        name: 'Abilitato',
        selector: (row) => (row.abilitato === 1 ? 'Sì' : 'No'),
        sortable: true,
        right: true,
        width: '140px',
      },
      {
        name: 'Azioni',
        cell: (row) => {
          const slug = encodeURIComponent(String(row.ID));
          return (
            <div style={{ display: 'flex', gap: 8 }}>
              <Button
                size="sm"
                color="primary"
                tag={Link as any}
                to={`/admin/tipologia/${slug}`}   // <-- pagina: tipologia/3
                onClick={(e: React.MouseEvent) => e.stopPropagation()}
              >
                Modifica
              </Button>

              <Button
                size="sm"
                color="danger"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(row);
                }}
              >
                Elimina
              </Button>
            </div>
          );
        },
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        width: '260px',
      },
    ],
    []
  );

  return (
    <Container fluid className="pt-2">
      <Col sm={12}>
        <Card>
          <CardBody>

            <div className='d-flex justify-content-between w-100  mb-5'>
              <H3>
                Permessi
              </H3>
              <div>
                <Link to="/admin/tipologia/new">
                  <Btn className="px-4" color="primary" type="button">
                    Nuovo
                  </Btn>
                </Link>
              </div>
            </div>


            <FilterComponent
              onFilter={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
              filterText={filterText}
            />

            <div className="table-responsive">
              <DataTable<PermissionTypeRow>
                data={filteredRows}
                columns={columns}
                progressPending={loading}
                progressComponent={<Loader />}
                pagination
                striped
                highlightOnHover
                className="display"
              />
            </div>
          </CardBody>
        </Card>
      </Col>
    </Container>
  );
}
